/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonFormatInfo,
    JsonFormatInfoFromJSON,
    JsonFormatInfoFromJSONTyped,
    JsonFormatInfoToJSON,
} from './JsonFormatInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonFormatInfo
 */
export interface ApiResultOfListOfJsonFormatInfo {
    /**
     * 
     * @type {Array<JsonFormatInfo>}
     * @memberof ApiResultOfListOfJsonFormatInfo
     */
    data?: Array<JsonFormatInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonFormatInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonFormatInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonFormatInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonFormatInfo
     */
    result?: ApiResultOfListOfJsonFormatInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonFormatInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonFormatInfoFromJSON(json: any): ApiResultOfListOfJsonFormatInfo {
    return ApiResultOfListOfJsonFormatInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonFormatInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonFormatInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonFormatInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonFormatInfoToJSON(value?: ApiResultOfListOfJsonFormatInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonFormatInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

